import { render, staticRenderFns } from "./ReceiptsCreateFormSidebar.vue?vue&type=template&id=39fe78ce&scoped=true"
import script from "./ReceiptsCreateFormSidebar.vue?vue&type=script&lang=js"
export * from "./ReceiptsCreateFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fe78ce",
  null
  
)

export default component.exports